<template>
  <el-card class="community-selector">
    <div class="treeview attendance-staff">
      <ul class="community-list">
        <li
          v-if="showAll"
          @click="selectAll"
          :class="{'selected': selectedCommunityId === ''}">
          全部
        </li>
        <li 
          v-for="(item, index) in communityList" 
          :key="index" 
          @click="selectCommunity(item)"
          :class="{'selected': selectedCommunityId === item.communityId}">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </el-card>
</template>

<script>
import { listAdminCommunitys } from '@/api/owner/adminOwnerApi'

export default {
  name: 'SelectAdminOneCommunity',
  props: {
    // 是否展示“全部”选项，默认展示
    showAll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      communityList: [],
      selectedCommunityId: ''
    }
  },
  created() {
    this.loadCommunities()
    // 默认选中“全部”
    if (this.showAll) {
      this.selectAll()
    }
  },
  methods: {
    loadCommunities() {
      const params = {
        page: 1,
        row: 100
      }

      listAdminCommunitys(params).then(res => {
        this.communityList = res.data
        // 不展示“全部”时，加载完成后默认选中第一个小区
        if (!this.showAll && this.communityList && this.communityList.length > 0) {
          this.selectCommunity(this.communityList[0])
        }
      }).catch(error => {
        console.log(error)
        this.$message.error(this.$t('adminOwner.fetchCommunityError'))
      })
    },
    selectAll() {
      this.selectedCommunityId = ''
      this.$emit('changeCommunity', { communityId: '', name: '全部' })
    },
    selectCommunity(community) {
      this.selectedCommunityId = community.communityId
      this.$emit('changeCommunity', community)
    }
  }
}
</script>

<style lang="scss" scoped>
.community-selector {
  max-height: 80vh;
  overflow-y: auto;
  .community-list {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      padding: 10px;
      cursor: pointer;
      transition: all 0.3s;
      color: #606060;
      font-size: 14px;
      
      &:hover {
        background-color: #f5f7fa;
      }
      
      &.selected {
        background-color: #409EFF;
        color: white;
      }
    }
  }
}
</style>